export default "__VITE_ASSET__CcRc$_G9__"